import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

class Tab extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    left: PropTypes.node,
    isActive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  render() {
    const { label, left, isActive, onClick, first } = this.props
    return (
      <div
        onClick={onClick}
        className={classNames(
          'pointer',
          'flexbox flexbox-align-center',
          'padding-horizontal-normal padding-vertical-small',
          'radius-normal',
          !first && 'margin-left-small',
          isActive
            ? 'primary primary-dark-on-hover background-primary-shade-light'
            : 'shade-10 background-shade-50-on-hover'
        )}
      >
        {left}
        <div className="font-weight-semibold font-size-large line-height-normal">
          {label}
        </div>
      </div>
    )
  }
}

class Tabs extends PureComponent {
  static propTypes = {
    options: PropTypes.array.isRequired,
  }

  render() {
    const { options, className } = this.props
    return (
      <div className={classNames('flexbox flexbox-align-center', className)}>
        {options.map((option, index) => (
          <Tab {...option} first={index === 0} key={index} />
        ))}
      </div>
    )
  }
}

export default Tabs
